import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppGlobals } from '@app/app.global';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private readonly http: HttpClient,
    private readonly appGlobals: AppGlobals) { }

  createCompany(payload: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}user-management/create-company`, payload);
  }

  updateCompany(payload: any) {
    return this.http.put<any>(`${this.appGlobals.apiUrl.authentication}user-management/update-company`, payload);
  }

  getCompanies() {
    return this.http.get<any>(`${this.appGlobals.apiUrl.authentication}user-management/get-company`);
  }

  getStates() {
    return this.http.get<any>(`${this.appGlobals.apiUrl.authentication}user-management/get-states`);
  }

  getCities(stateId: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.authentication}user-management/get-city?state=${stateId}`);
  }

  updateCompanyFeatureSettings(payload: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}user-management/company-feature-settings`, payload);
  }

  updateUserFeatureSettings(payload: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}user-management/user-feature-settings`, payload);
  }

  gstDetail(payload: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}gst-detail`, payload);
  }

  requestCallBack(params) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.authentication}user-management/request-callback`, { params });
  }

  changeCompanyStatus(body) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}user-management/change-company-status`, body);
  }
}
